import { useState, useEffect } from 'react';
import axios from 'axios';

export function Totals() {
  const [error, setError] = useState();
  const [totalDonors, setTotalDonors] = useState();
  const [totalPayments, setTotalPayments] = useState();
  const [hideStats, setHideStats] = useState(true);

  useEffect(() => {
    const getTotals = async () => {
      await axios.get(`/statistics`)
        .then((response) => {
          setTotalDonors(response.data.personsPaidCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));
          let formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', });
          setTotalPayments(formatter.format(response.data.paymentsTotal));
          setHideStats(false);
        }).catch(function (error) {
          let errorMessage = `Error: ${error.message}`;
          if (error.response) {
            errorMessage += `\nStatus Code: ${error.response.status}\nRoute: ${error.response.config.url}`;
          }
          setError(errorMessage);
        });
    }
    getTotals();
  }, [])

  if (error)
    return (<h2><b>Problem loading donation totals: {error}</b></h2>);
  else {
    return (
      <div hidden={hideStats} className="row">
        <div className="col-sm-12">
          <p className="text-center">Join <b>{totalDonors}</b> supporters who have donated <b>{totalPayments}</b> so far!</p>
        </div>
      </div>
    );
  }
}
